import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DxButtonModule } from "devextreme-angular";

@Component({
  selector: "app-action-button",
  standalone: true,
  imports: [DxButtonModule],
  templateUrl: "./action-button.component.html",
  styleUrl: "./action-button.component.scss",
})
export class ActionButtonComponent {
  @Input() action: string = "";
  @Input() type: "default" | "normal" | "danger" | "success" = "default";
  @Input() label: string = "";
  @Input() icon: string = "";
  @Input() isDisabled: boolean = false;
  @Input() title: string = "";

  @Output("ctmClick") click: EventEmitter<string> = new EventEmitter();
}
